
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/[...slug]",
      function () {
        return require("private-next-pages/[locale]/[...slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/[...slug]"])
      });
    }
  